import { Box, Dialog,Menu,MenuItem} from '@mui/material'
import React, { useState } from 'react'
import MoreVertIcon from '@mui/icons-material/MoreVert';
import styled from '@emotion/styled';


const MenuOption=styled(MenuItem)`
    font-size:14px;
    padding: 15px 60px 5px 24px;
    color:#4A4A4A
    `



function HeaderMenu({setOpen}) {

    const[open,SetOpen]=useState(null)


    const handleClose=()=>{
        SetOpen(null)
    }

    const handleClick=(e)=>{
        SetOpen(e.currentTarget)
    }

    return (
       <>
        <MoreVertIcon
            onClick={handleClick}
        />
        <Menu
        
        anchorEl={open}
        keepMounted
        open={open}
        getContentAnchorE1={null}
        onClose={handleClose}
        anchorOrigin={{
            vertical:"bottom",
            horizontal:"center"
        }}
        transformOrigin={{
            vertical:"top",
            horizontal:'right'
        }}
      >
        <MenuOption onClick={()=>{handleClose();setOpen(true); }}>Profile</MenuOption>
        <MenuOption onClick={handleClose}>My account</MenuOption>
        <MenuOption onClick={handleClose}>Logout</MenuOption>
      </Menu>
       </>
    )
}

export default HeaderMenu
